/**
 * HomeENSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeENSiteHeaderLanguages
 */

import { useHomeENSiteHeaderLanguagesLogic } from '@/hooks/traits/useHomeENSiteHeaderLanguagesLogic';
import type { HomeENSiteHeaderLanguagesConfig } from '@/hooks/traits/useHomeENSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeENAlmadarHomeView as HomeENAlmadarHomeViewEntity } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Menu } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeENSiteHeaderLanguagesViewProps {
  config?: Partial<HomeENSiteHeaderLanguagesConfig>;
}

export function HomeENSiteHeaderLanguagesView({ config: propsConfig }: HomeENSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeENSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeENAlmadarHomeView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeEN" trait="HomeENSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu position="bottom-end" items={Array.isArray(([{ label: "English" as const, code: "en" as const, href: "/" as const }, { label: "العربية" as const, href: "/ar" as const, code: "ar" as const }, { code: "sl" as const, href: "/sl" as const, label: "Slovenščina" as const }]).map((entry) => ({ id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), label: (getNestedValue(entry, "label") ?? "") }))) ? (((([{ label: "English" as const, code: "en" as const, href: "/" as const }, { label: "العربية" as const, href: "/ar" as const, code: "ar" as const }, { code: "sl" as const, href: "/sl" as const, label: "Slovenščina" as const }]).map((entry) => ({ id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), label: (getNestedValue(entry, "label") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} trigger={<Button icon="globe" variant="ghost" label={String(__locale.toUpperCase())} size="sm" />} className={((([{ href: "/" as const, label: "English" as const, code: "en" as const }, { label: "العربية" as const, code: "ar" as const, href: "/ar" as const }, { href: "/sl" as const, label: "Slovenščina" as const, code: "sl" as const }]).length === 0)) ? "hidden" : ""} />) : null}
    </TraitScopeProvider>
  );
}

export default HomeENSiteHeaderLanguagesView;
